import React from 'react';
import { Box, Card, Grid2 as Grid, Skeleton } from "@mui/material";

export const PlaceDetailSkeleton = () => {
    return (
        <Box sx={{ width: "100%", p: 2, direction: "rtl" }}>
            {/* Top Bar Skeleton */}
            <Skeleton
                variant="rounded"
                animation="wave"
                height={52}
                sx={{ width: "100%", mb: 2, borderRadius: 3 }}
            />

            <Grid container spacing={2}>
                {/* Column 1 */}
                <Grid size={{ xs: 12, md: 6 }}>
                    {/* Image Carousel Skeleton */}
                    <Card elevation={4} sx={{ borderRadius: 3, mb: 2, overflow: "hidden" }}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            sx={{ width: "100%", height: 240, aspectRatio: "16 / 9" }}
                        />
                    </Card>

                    {/* Base Info Skeleton */}
                    <Card elevation={3} sx={{ borderRadius: 3, p: 2, mb: 2 }}>
                        <Skeleton variant="text" animation="wave" width="60%" height={36} sx={{ mb: 1 }} />
                        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                            <Skeleton variant="rounded" animation="wave" width={80} height={26} sx={{ borderRadius: 2 }} />
                            <Skeleton variant="rounded" animation="wave" width={90} height={26} sx={{ borderRadius: 2 }} />
                        </Box>
                        <Skeleton variant="text" animation="wave" width="90%" height={22} />
                        <Skeleton variant="text" animation="wave" width="75%" height={22} />
                    </Card>
                </Grid>

                {/* Column 2 */}
                <Grid size={{ xs: 12, md: 6 }}>
                    {/* Address & Contact Skeleton */}
                    <Card elevation={3} sx={{ borderRadius: 3, p: 2, mb: 2 }}>
                        <Skeleton variant="text" animation="wave" width="40%" height={28} sx={{ mb: 1.5 }} />
                        <Skeleton variant="text" animation="wave" width="95%" height={20} />
                        <Skeleton variant="text" animation="wave" width="80%" height={20} sx={{ mb: 2 }} />
                        <Skeleton variant="rounded" animation="wave" height={100} sx={{ borderRadius: 2 }} />
                    </Card>

                    {/* Facilities Skeleton */}
                    <Card elevation={3} sx={{ borderRadius: 3, p: 2, mb: 2 }}>
                        <Skeleton variant="text" animation="wave" width="45%" height={28} sx={{ mb: 2 }} />
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {[1, 2, 3, 4, 5, 6].map((f) => (
                                <Skeleton key={"fac-skel-" + f} variant="rounded" animation="wave" width={70} height={32} sx={{ borderRadius: 2 }} />
                            ))}
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PlaceDetailSkeleton;
